export enum ApplicationTwoFactorAuth {
  None = 0,
  Optional = 1,
  Required = 2
}
